let initialTime = new Date().getTime();

const trackPerformance = (name) => {
  const now = new Date().getTime();
  const time = now - initialTime;
  initialTime = now;

  window.performance &&
    window.performance.mark &&
    window.performance.mark(`${name} - ${time}ms`);
};

export default trackPerformance;
